import { getVersionedCallbackUrl, redirectToWebform } from "@repo/shared-utils/common-utils";
import { SSORedirectHandler } from "../../../../apps/trading-mall-app/app/components/ClickHandler/RedirectionConfig.interface";

export const cartHandler: SSORedirectHandler = async (data) => {
  const callbackUrl = await getVersionedCallbackUrl(data.mapping);
  const formData = {
    cart: true,
  };
  redirectToWebform(callbackUrl.toString(), formData);
};
